export default __webpack_public_path__ + "static/media/Group 3223@2x.6d0874b3.png";